import React from 'react';
import { Routes, Route } from "react-router-dom";

import Home from './components/home';
import Trainer from './components/trainer';
import Leaderboard from './components/leaderboard';
import TeamPage from './components/teampage';
import AdminPage from './components/adminpage';
import Submission from './components/submission';

import Navbar from './components/navbar';
import Footer from './components/footer';

import 'react-toastify/dist/ReactToastify.css';

import Register from './components/auth/register';
import Login from './components/auth/login';
import Logout from './components/auth/logout';

import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";

import "./index.css";
import ChallengeFilesPage from './components/challengefiles';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <ToastContainer 
      position="bottom-left"
    />
    <Navbar />

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/trainer" element={<Trainer />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/teampage" element={<TeamPage />} />
      <Route path="/submission" element={<Submission />} />
      <Route path="/adminpage" element={<AdminPage />} />
      <Route path="/challengedata" element={<ChallengeFilesPage />} />

      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>

    <Footer />

    
  </BrowserRouter>
);


// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Home />,
//   },
//   {
//     path: "/trainer",
//     element: <Trainer />,
//   },
//   {
//     path: "/leaderboard",
//     element: <Leaderboard />,
//   },
//   {
//     path: "/teampage",
//     element: <TeamPage />,
//   },
//   {
//     path: "/adminpage",
//     element: <AdminPage />,
//   }
// ]);

// ReactDOM.createRoot(document.getElementById("root")).render(
//   <div>
    
//     <RouterProvider router={router}>
//       <Navbar />
//       <Footer />
//     </RouterProvider>
    
//   </div>
// );
